import styled from 'styled-components';

interface ButtonProps{
  variant?: 'primary' | 'secondary' | 'ghost' | 'green' | 'blue' | 'link' | 'delete' | 'text';
  size?: 'small' | 'medium' | 'large';
  fullwidth?: boolean;
  padding?: string;
  disabled?: boolean;
}

export const Button = styled.button<ButtonProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 6px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  outline: none;
  font-family: inherit;
  opacity: ${props => props.disabled ? 0.5 : 1};

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &:active {
    outline: none;
  }
  
 

  ${props => {
    switch (props.size) {
      case 'small':
        return `
          padding: 8px 16px;
          font-size: 12px;
        `;
      case 'large':
        return `
          padding: 12px 24px;
          font-size: 16px;
        `;
      case 'medium':
        return `
          padding: 10px 20px;
          font-size: 14px;
        `;
      default:
        return `
          padding: 10px 30px;
          font-size: 14px;
        `;
    }
  }}
  ${props => props.fullwidth && `
    width: 100%;
  `}
  ${props => props.padding && `
    padding: ${props.padding};
  `}
  ${props => {
    switch (props.variant) {
      case 'primary':
        return `
          background: ${props.theme.colors.primary};
          border: none;
          color: white;
          
          &:hover {
            background: ${props.theme.colors.buttons.hover.primary};
          }
        `;
      case 'secondary':
        return `
          background: rgb(227, 227, 227);
          border: 1px solid #e0e0e0;
          color: rgb(0, 0, 0);
          font-weight: 400;
        
        `;
      case 'delete':
        return `
          background: white;
          border: none;
          color: rgb(219, 51, 36);
          &:hover {
            background: ${props.theme.colors.buttons.hover.delete};
          }
        `;
      case 'link':
        return `
          padding: 0 !important;
          background: transparent;
          border: none;
          color: ${props.theme.colors.primary};
          cursor: pointer;
          padding: 3px 10px;
          font-size: 14px;
          &:hover {
            text-decoration: underline;
            background: transparent;
          }
        `;
      case 'text':
        return `
          padding: 0 !important;
          background: transparent;
          border: none;
          cursor: pointer;
          padding: 3px 10px;
          font-size: 14px;
          &:hover {
            background: transparent;
          }
        `;
      case 'ghost':
        return `
          background: transparent;
          border: none;
          color: ${props.theme.colors.primary};
          
          &:hover {
            background: rgba(77, 105, 156, 0.1);
          }
        `;
      case 'green':
        return `
          background: ${props.theme.colors.green};
          border: none;
          color: white;
          
          &:hover {
            background: ${props.theme.colors.buttons.hover.green};
          }
        `;
      case 'blue':
        return `
          background: ${props.theme.colors.blue};
          border: none;
          color: white;
          
          &:hover {
            background: ${props.theme.colors.buttons.hover.blue};
          }
        `;
    }
  }}
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
